'use strict';

function HolidaysAndSpecialsEventsPanelDirective() {
  return {
    controller: 'HolidaysAndSpecialsEventsPanelController',
    replace: true,
    restrict: 'E',
    scope: {
      screenState: '='
    },
    template: require('../templates/holidays-and-special-events-panel.html'),
    link: function link($scope) {
      $scope.$on('grid:manual-refresh:' + $scope.gridId, function () {
        $scope.refreshGrid();
      });
    }
  };
}
HolidaysAndSpecialsEventsPanelDirective.$inject = [];
module.exports = HolidaysAndSpecialsEventsPanelDirective;